var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseChoice',{attrs:{"title":"関連付けるブランドを選択してください","resourceType":"brand","fields":_vm.fields,"items":_vm.brand.brands,"totalItems":_vm.totalBrands,"isFetching":_vm.isFetching}})}
var staticRenderFns = []

export { render, staticRenderFns }